import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';

export default class VerificationInstructions extends Component {
  render() {
    return (
      <Message>
        <Message.Header>Enter percentages using this format:</Message.Header>
        <Message.Content>3% = 3.00</Message.Content>
        <Message.Content>1% = 1.00</Message.Content>
        <Message.Content>1/2% = 0.50</Message.Content>
        <br />
        <Message.Header>Please Enter an Error Prone Limit:</Message.Header>
        <Message.Content>
          Enter the monthly limit for error prone applications.
        </Message.Content>
        <Message.Content>$100 = 100</Message.Content>
      </Message>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/components/Instructions.js